"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Layers, TrendingUp, Briefcase } from "lucide-react";
export default function Services() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const services = [{
    icon: Layers,
    title: "Deal Origination",
    description: "Off-market sourcing and opportunity identification. We create deals before they reach the market, leveraging deep industry networks and strategic intelligence.",
    link: "#"
  }, {
    icon: TrendingUp,
    title: "Development Advisory",
    description: "Land acquisition strategy, entitlement consulting, and project feasibility analysis. Strategic guidance through every phase of the development lifecycle.",
    link: "#"
  }, {
    icon: Briefcase,
    title: "Brokerage Execution",
    description: "Luxury residential sales, commercial investment transactions, and developer representation. Institutional-grade execution for sophisticated clients.",
    link: "#"
  }];
  return <section id="services" ref={sectionRef} className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl lg:text-5xl font-display uppercase tracking-wider text-foreground-dark mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Strategic real estate advisory across the complete development and transaction lifecycle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`bg-dark-section border border-border/30 hover:border-accent/50 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.02] group ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader className="text-center">
                  <div className="flex justify-center mb-6">
                    <div className="relative">
                      <div className="w-1 h-12 bg-accent mx-auto mb-4" />
                      <Icon className="w-12 h-12 text-accent transition-all duration-[var(--duration-medium)] group-hover:drop-shadow-[0_0_12px_rgba(64,224,208,0.6)]" strokeWidth={1.5} />
                    </div>
                  </div>
                  <CardTitle className="text-2xl text-foreground-dark mb-3">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground text-base leading-relaxed mb-6">
                    {service.description}
                  </CardDescription>
                  <Link to={service.link} className="inline-block text-accent font-semibold uppercase text-sm tracking-wide hover:tracking-wider transition-all duration-[var(--duration-fast)] focus-ring">
                    Learn More →
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}